import React from 'react';
import PostsTable from './DashboardLayout/PostsTable';
import './styles/DashboardLayout.less';

const DashboardLayout = () => (
  <div className="dashboard-container">
    <h3 className="dashboard-header">Bienvenido</h3>
    <div className="dashboard-content">
      <PostsTable />
    </div>
  </div>
);

export default DashboardLayout;
